export default __webpack_public_path__ + "static/media/logo-omniq-01.96671906.svg";